import BaseButton, { BasicButtonProtypes } from './base-button';

import PropTypes from 'prop-types';
import styles from 'styles/Buttons.module.scss';

export const PinkButton = ({
    label,
    onClick,
    endIcon,
    startIcon,
    whiteBorder,
    buttonID,
    divID,
    propsButton,
    href,
    disabled = false
}) => {
    return (
        <BaseButton
            divClass={styles.buttonContainer}
            buttonClass={
                !whiteBorder ? styles.pinkButton : styles.pinkButtonWhiteBorder
            }
            label={label}
            onClick={onClick}
            startIcon={startIcon}
            endIcon={endIcon}
            buttonID={buttonID}
            divID={divID}
            propsButton={propsButton}
            href={href}
            disabled={disabled}
        />
    );
};

PinkButton.propTypes = {
    ...BasicButtonProtypes,
    whiteBorder: PropTypes.bool
};

export const BlackButton = ({ label, onClick, endIcon, startIcon, href }) => {
    return (
        <BaseButton
            divClass={styles.buttonContainer}
            buttonClass={styles.blackButton}
            label={label}
            onClick={onClick}
            startIcon={startIcon}
            endIcon={endIcon}
            href={href}
        />
    );
};
BlackButton.propTypes = BasicButtonProtypes;

export const WhiteButton = ({
    label,
    onClick,
    endIcon,
    startIcon,
    whiteBorder,
    href,
    compact = false
}) => {
    return (
        <BaseButton
            divClass={styles.buttonContainer}
            buttonClass={`${!whiteBorder ?
                styles.whiteButton :
                styles.whiteButtonWhiteBorder}
                ${compact ? styles.lowPadding : ''}
            `}
            label={label}
            onClick={onClick}
            startIcon={startIcon}
            endIcon={endIcon}
            href={href}
        />
    );
};

WhiteButton.propTypes = {
    ...BasicButtonProtypes,
    whiteBorder: PropTypes.bool
};

export const TransparentButton = ({
    label,
    onClick,
    endIcon,
    startIcon,
    compact,
    href,
    propsButton
}) => {
    return (
        <BaseButton
            divClass={styles.buttonContainer}
            buttonClass={
                !compact ?
                    styles.transparentButton :
                    styles.transparentButtonCompact
            }
            label={label}
            onClick={onClick}
            startIcon={startIcon}
            endIcon={endIcon}
            href={href}
            propsButton={propsButton}
        />
    );
};

TransparentButton.propTypes = {
    ...BasicButtonProtypes,
    compact: PropTypes.bool
};
